import { useSnapshot } from 'valtio'
import React, { type ReactElement, useEffect } from 'react'
import { customerProxy } from '../../../../../shared/proxies/customerProxy'
import { executeCustomerCardsSearchForCustomerDetail } from '../../../../../shared/apiUtils/executeCardsSearch'
import {
  currentCardBrandFromString
} from '../../../virtual-terminal/index/Payment/PaymentDetails/CardLogo/utils'
import { CardDeleteButton } from './CardDeleteButton'
import { CardFavoriteButton } from './CardFavoriteButton'

export function CustomerCardsSection (): ReactElement {
  const { customer, customerCards, customerCard } = useSnapshot(customerProxy)
  useEffect(() => {
    void executeCustomerCardsSearchForCustomerDetail()
  }, [customer?.id, customerCard])

  return (
    <>
      <div className="py-4 flex flex-row flex-wrap">
        {customerCards?.map((card, idx) => {
          return (
            <div className="grid grid-cols-2 grid-rows-2 bg-white shadow rounded p-4 my-4 mr-4 w-1/3 max-w-[30%]" key={idx}>

              {currentCardBrandFromString(card.cardBrand)}
              <div>
                <CardFavoriteButton cardId={card.id} isPrimary={card.isPrimary} />
                <CardDeleteButton customerCard={card} />
              </div>
              <div className=" pt-4 text-xl">
                {card.cardNumber}
              </div>

              <div className=" pt-4 text-xl text-right">{card.expirationMonth}/{card.expirationYear}</div>

            </div>
          )
        })}
      </div>
    </>
  )
}
